<template>
  <v-layout row wrap>
    <v-flex xs12 lg6>
      <v-menu
        ref="menu1"
        v-model="menu1"
        :close-on-content-click="false"
        :nudge-right="40"
        lazy
        transition="scale-transition"
        offset-y
        full-width
        max-width="290px"
        min-width="290px"
        :color="Theme.GREEN"
        :return-value="dateCopy"
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            v-model="getDateFormatted"
            :label="getDateString"
            :color="Theme.GREEN"
            @blur="$emit('update:date', parseDate(dateFormatted))"
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker v-model="dateCopy" :color="Theme.GREEN"
                       no-title @input="updateDate(date)"></v-date-picker>
      </v-menu>
    </v-flex>
  </v-layout>
</template>

<script>
import common from "@/mixins/common";

export default {
  name: "DatePicker",
  mixins:[common],
  props: {
    'date': String,
    dateString: String,
  },
  data() {
    return {
      dateFormatted: '',
      dateCopy: this.date,
      menu1: false,
    };
  },
  watch: {
    date() {
      this.dateFormatted = this.formatDate(this.dateCopy);
    }
  },
  computed: {
    getDateFormatted(){
      return this.formatDate(this.dateCopy);
    },
    getDateString(){
      return this.dateString && this.dateString !=='' ? this.dateString : `日期`;
    }
  },
  methods: {
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${year}/${month}/${day}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [month, day, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    updateDate() {
      this.menu1 = false;
      this.$emit("updateDate", this.dateCopy);
    }
  },
};
</script>
